import { InfoM } from '@app/modules/audit/modules/aod/screens/aod-rule-view/components/InfoM';
import { UserRole } from '@mi-front/core';
import { Box, Grid } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { UserWithGroup } from '../../../../../../core/types/users';
import { loginMethodIconMap } from '../../components/LoginMethodIconMap';
import { UserRoleInfo } from '../../components/UserRoleInfo';
import { loginMethodLabelMessages } from '../../messages';

interface Props {
  readonly user: UserWithGroup;
  readonly canEdit: boolean;
}

export function UserInfo(p: Props) {
  const { user, canEdit } = p;
  const { $t } = useIntl();

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InfoM
            label={$t({
              id: 'common.email',
              defaultMessage: 'Email',
            })}
          >
            {user.email}
          </InfoM>
        </Grid>
        {user.loginMethod && (
          <Grid item xs={12}>
            <InfoM
              label={$t({
                id: 'admin.users.loginMethod.label',
                defaultMessage: 'Método de login',
              })}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {loginMethodIconMap[user.loginMethod]}{' '}
                {$t(loginMethodLabelMessages[user.loginMethod])}
              </Box>
            </InfoM>
          </Grid>
        )}
        <Grid item xs={12}>
          <InfoM
            label={
              <FormattedMessage
                id="admin.users.viewScreen.fullName"
                defaultMessage="Nombre completo"
              />
            }
          >
            {user.name ? (
              `${user.name} ${user.surname}`
            ) : (
              <Box component="span" sx={{ color: 'text.secondary' }}>
                (
                <FormattedMessage id="common.text.notSet" defaultMessage="No establecido" />)
              </Box>
            )}
          </InfoM>
        </Grid>
        <Grid item xs={12}>
          <InfoM
            label={
              <FormattedMessage
                id="admin.users.viewScreen.userRole"
                defaultMessage="Rol de usuario"
              />
            }
          >
            <UserRoleInfo value={user.role} />
          </InfoM>
        </Grid>
        {user.role === UserRole.CLIENT_USER && (
          <Grid item xs={12}>
            <InfoM
              label={
                <FormattedMessage
                  id="admin.users.viewScreen.assignedGroup.title"
                  defaultMessage="Grupo asignado"
                />
              }
            >
              {user.group ? (
                user.group.name
              ) : (
                <Box component="span" sx={{ color: 'text.secondary' }}>
                  <FormattedMessage
                    id="admin.users.viewScreen.assignedGroup.noGroup"
                    defaultMessage="- Sin grupo -"
                  />
                </Box>
              )}
            </InfoM>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
